import { Plus, Trash2 } from 'lucide-react';
import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function SendGridConfig({ data, onChange }) {
  const baseFields = NODE_CONFIG_FIELDS.action_sendgrid;
  const contentType = data.contentType || 'html';
  const templateData = data.templateData || [];

  const addParam = () => {
    onChange('templateData', [...templateData, { key: '', value: '' }]);
  };

  const updateParam = (index, field, value) => {
    const updated = templateData.map((p, i) => (i === index ? { ...p, [field]: value } : p));
    onChange('templateData', updated);
  };

  const removeParam = (index) => {
    onChange('templateData', templateData.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      {baseFields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}

      <div className="h-px bg-gray-100 my-1" />

      {contentType === 'template' ? (
        <>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">Template ID</label>
            <ConfigField
              field={{ key: 'templateId', type: 'text', placeholder: 'd-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' }}
              value={data.templateId}
              onChange={(v) => onChange('templateId', v)}
              allData={data}
              onChangeField={onChange}
            />
          </div>

          <div>
            <div className="flex items-center justify-between mb-1.5">
              <label className="text-xs font-medium text-gray-600">Template Parameters</label>
              <button
                type="button"
                onClick={addParam}
                className="flex items-center gap-1 px-2 py-1 text-[11px] font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition"
              >
                <Plus className="w-3 h-3" />
                Add
              </button>
            </div>
            {templateData.length === 0 && (
              <p className="text-xs text-gray-400 text-center py-2">No parameters yet.</p>
            )}
            {templateData.map((param, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-2 mb-1.5 space-y-1.5">
                <div className="flex items-center gap-1.5">
                  <input
                    type="text"
                    value={param.key}
                    onChange={(e) => updateParam(index, 'key', e.target.value)}
                    placeholder="Key"
                    className="flex-1 min-w-0 px-2 py-1.5 text-xs border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-blue-400 font-mono"
                  />
                  <button
                    type="button"
                    onClick={() => removeParam(index)}
                    className="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition shrink-0"
                  >
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                </div>
                <ConfigField
                  field={{ key: `param-${index}`, type: 'text', placeholder: 'Value (supports {{variables}})' }}
                  value={param.value}
                  onChange={(v) => updateParam(index, 'value', v)}
                  allData={data}
                  onChangeField={onChange}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">
            {contentType === 'html' ? 'HTML Body' : 'Text Body'}
          </label>
          <ConfigField
            field={{ key: 'content', type: 'textarea', placeholder: contentType === 'html' ? '<p>Hello {{user.name}}</p>' : 'Email body...' }}
            value={data.content}
            onChange={(v) => onChange('content', v)}
            allData={data}
            onChangeField={onChange}
          />
        </div>
      )}
    </div>
  );
}
